import React from 'react'
import { useAccordionContext } from '../AccordionContext'
import classNames from 'classnames'

export const AccordionBody = ({ className, classnames, ...props }) => {
  const { visible } = useAccordionContext()

  const classes = classNames(['accordion-body-content', 'overflow-hidden'], className)
  const wrapperClassName = classNames(['accordion-body', 'transition-regular', 'grid'], classnames?.wrapper, { '--visible': visible })

  return (
    <div className={wrapperClassName} tabIndex={-1} aria-hidden={!visible}>
      <div className={classes} {...props} />
    </div>
  )
}

export default AccordionBody

